module.exports = __webpack_public_path__ + "img/environment_img.0bcc6d79.png";